import styled, { css } from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const LineContainer = styled.div`
  gap: ${Spacing.HALF};
  width: 100%;
  ${Mixins.Flex.setColumn('flex-start', 'center')}
`;

export const LineHighlight = styled.div`
  background: ${Colors.GRAY_LITE_30};
  width: 100%;
  padding: ${Spacing.HALF} ${Spacing.SINGLE};
`;

export const Line = styled.div`
  gap: ${Spacing.HALF};
  width: 100%;
  ${Mixins.Flex.set('space-between', 'center')}
`;

export const TextContainer = styled.div`
  gap: ${Spacing.HALF};
  overflow: hidden;
  ${Mixins.Flex.set('flex-start', 'center')}
`;

export const Tag = styled.p`
  background: ${Colors.KOHLRABI_LITE_30};
  border-radius: ${Border.Radius.S};
  display: inline-flex;
  margin: 0;
  padding: ${Spacing.EIGHTH} ${Spacing.HALF};
  ${Font.bySize(Font.Size.XS, Font.Weight.SEMI_BOLD)}
  ${Mixins.Text.overflow(1)}
`;

export const BaseText = styled.p`
  margin: 0;
`;

export const Text = styled(BaseText)<{ crossed?: boolean }>`
  ${Font.bySize(Font.Size.S, Font.Weight.NORMAL)}
  ${Mixins.Media.maxWidthSmall(css`
    font-size: ${Font.Size.XS};
  `)}
  ${({ crossed = false }) =>
    crossed
      ? css`
          color: ${Colors.GRAY};
          text-decoration: line-through;
        `
      : ''}
`;

export const BoldText = styled(BaseText)`
  ${Font.bySize(Font.Size.S, Font.Weight.BOLD)}
  ${Mixins.Media.maxWidthSmall(css`
    font-size: ${Font.Size.XS};
  `)}
`;

export const Divider = styled.hr`
  padding: 0;
  margin: 0;
  width: 100%;
  border-top: ${Border.Base} ${Colors.GRAY_LITE_20};
`;

export const DiscountText = styled(Text)`
  color: ${Colors.KOHLRABI_DARK_10};
`;

export const SavingsContainer = styled.div`
  background: ${Colors.KOHLRABI_LITE_30};
  border-radius: ${Border.Radius.M};
  color: ${Colors.KOHLRABI_DARK_10};
  padding: ${Spacing.THREE_QUARTERS} ${Spacing.HALF};
  text-align: center;
  width: 100%;
`;
